import { render } from "./type-forms.vue?vue&type=template&id=72512e58&scoped=true"
import script from "./type-forms.vue?vue&type=script&lang=js"
export * from "./type-forms.vue?vue&type=script&lang=js"

import "./type-forms.vue?vue&type=style&index=0&id=72512e58&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72512e58"]])

export default __exports__